import { useObserve } from "@legendapp/state/react";
import { Spinner } from "@repo/ui/ui/spinner";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { user$ } from "~/stores/auth";

/**
 * Post-OAuth landing page. Better-auth's `signIn.social` redirects browsers
 * here after Google sets the session cookie. The page intentionally has no
 * `beforeLoad` gate so it isn't routed through `_app/route` (which would
 * see `auth$` as still-null on a cold load and bounce to `/login`). Once
 * the eager `authClient.getSession()` from `auth.store.ts` resolves and
 * pipes data into `auth$`, `user$.id` flips non-empty and we navigate to
 * the original destination.
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { redirect } = Route.useSearch();
  useObserve(() => {
    const id = user$.id.get();
    if (!id) return;
    queueMicrotask(() => navigate({ to: redirect ?? "/", replace: true }));
  });
  return (
    <div className="flex h-svh w-svw items-center justify-center">
      <Spinner className="size-6" />
    </div>
  );
};

export const Route = createFileRoute("/auth/callback")({
  validateSearch: z.object({
    redirect: z
      .string()
      .optional()
      .refine((v) => !v || (v.startsWith("/") && !v.startsWith("//"))),
  }),
  component: AuthCallback,
});
